import { render, staticRenderFns } from "./StudentsAchievements.vue?vue&type=template&id=2ccbd608&scoped=true&"
import script from "./StudentsAchievements.vue?vue&type=script&lang=js&"
export * from "./StudentsAchievements.vue?vue&type=script&lang=js&"
import style0 from "./StudentsAchievements.vue?vue&type=style&index=0&id=2ccbd608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbd608",
  null
  
)

export default component.exports